import { ReactNode, useState } from "react";
import styles from "./index.module.css";
import { createPortal } from "react-dom";
import cx from "classnames";
type SearchBarProps = {
  toggleSearchBox: () => void;
  isOpen?: boolean;
  onSubmit?: (fieldValue: string) => void;
  value?: string;
  placeholder?: string;
  searchIcon?: ReactNode;
  closeIcon?: ReactNode;
};

export default function SearchBar({
  toggleSearchBox,
  isOpen = false,
  onSubmit = () => {},
  value = "",
  placeholder = "Search for",
  searchIcon,
  closeIcon,
}: SearchBarProps) {
  const [fieldValue, setFieldValue] = useState(value);
  return (
    <form
      style={{ display: !isOpen ? "none" : "flex" }}
      className={cx(styles.container)}
      onSubmit={(e) => {
        e.preventDefault();
        onSubmit(fieldValue);
        toggleSearchBox();
      }}
    >
      {searchIcon && <span className={styles.searchIcon}>{searchIcon}</span>}
      {isOpen && (
        <input
          className={styles.textInput}
          value={fieldValue}
          placeholder={placeholder}
          maxLength={1000}
          onChange={(e) => setFieldValue(e.target.value)}
          autoFocus
        />
      )}
      {closeIcon && (
        <button
          type="button"
          className={styles.closeIcon}
          onClick={() => toggleSearchBox()}
        >
          {closeIcon}
        </button>
      )}
    </form>
  );
}

export function SearchBarPortal(props: SearchBarProps) {
  return createPortal(<SearchBar {...props} />, document.body);
}
